import { Experience } from '../types';

export const experienceData: Experience[] = [
  {
    id: "streamio-ai",
    company: "StreamIO.AI (an Optimum Vertex Company)",
    position: "Founder & CEO",
    startDate: "06/2025",
    endDate: "Present",
    location: "San Francisco, Bay Area, CA",
    description: "Founder & CEO, and leading the development of StreamIO.AI, a web and native macOS, Windows, and Linux app providing secure, intelligent, and interactive live digital content with real-time AI-powered insights and seamless macOS integration.",
    technologies: ["Swift", "macOS", "AI/ML", "Kinde", "TypeScript", "Node.js", "LLM Models", "Web", "Windows", "Linux"],
    achievements: [
      "Launched StreamIO.AI on web, and MacOS, Windows, and Linux as a secure, intelligent partner for live digital content, integrating real-time AI-powered insights.",
      "Implemented web and native macOS integration for seamless user experience.",
      "Led go-to-market strategy and customer acquisition efforts, including executing customer discovery interviews and refining the product based on user feedback."
    ],
    current: true,
    logo: "/assets/images/StreamIO.png",
    link: "https://www.streamio.ai"
  },
  {
    id: "fintellect-ai",
    company: "Fintellect AI (Optimum Vertex Co)",
    position: "Founder & CEO",
    startDate: "07/2024",
    endDate: "Present",
    location: "SF Bay Area, CA",
    description: "Pioneered the development of FintellectAI, a mobile-first AI-powered platform democratizing financial intelligence as a personalized financial education and investment platform designed to make complex financial concepts accessible to both beginner and experienced investors through an AI-guided experience.",
    technologies: ["Python", "Java", "Auth0", "MongoDB", "Kinde", "Stripe", "Next.js", "LLM Models", "iOS", "Android"],
    achievements: [
      "Directed 0-1 product strategy and innovation, leading a cross-functional team to launch key features such as advanced asset class analysis, AI-driven chart insights, and macroeconomic and fundamental tools across all asset classes.",
      "Implemented mobile and web front-end development and scalable backend infrastructure with a seamless user experience by integrating frontier and open-source LLM Models.",
      "Led go-to-market strategy and customer acquisition efforts, including executing customer discovery interviews and refining the product based on user feedback."
    ],
    current: true,
    logo: "/assets/images/app-learn.gif",
    link: "https://www.fintellectai.io"
  },
  {
    id: "intuit",
    company: "Intuit Inc",
    position: "Staff Product Manager",
    startDate: "06/2021",
    endDate: "09/2024",
    location: "Mountain View, CA",
    description: "Senior Staff Product Manager for In-Session Customer Engagement (ICE), Services Paved Road (k8s Microservices), Asterias, JSK.",
    technologies: ["Cloud", "Microservices", "Kubernetes", "Node.js", "React", "Java", "AWS", "GCP"],
    achievements: [
      "Achieved 275% YoY growth in ICE engagements, scaling to 675M+ in FY23.",
      "Onboarded new use cases across mobile, web, backend, and desktop platforms, increasing developer adoption by 4x.",
      "Launched ICE Playground and Presence Capability, improving developer testing efficiency.",
      "Delivered ICE Self-Service offering, automating onboarding (50% faster) and reducing troubleshooting by 30%.",
      "Implemented ICE Presence in async chat, generating $480K/month in additional invoicing.",
      "Deployed Background-to-Foreground Messaging on iOS/Android, achieving 95%+ delivery success and <100ms latency, improving engagement and retention.",
      "Migrated to rSocket, increasing network performance by 15% and reducing errors by 25%.",
      "Scaled ICE throughput from 6K to 50K TPS, enabling high-throughput distributed routing.",
      "Developed Event Delivery with Acknowledgement, boosting reliability to 98% delivery success and reducing failures by 20%.",
      "Transitioned Paved Road Templates reducing asset management effort by 30%.",
      "Led product development for containerized real-time event delivery services via rSocket over WebSocket, supporting multi-tenant Kubernetes infrastructure and multiplexed eventing channels.",
      "Built multi-language containerized platform services for MSaaS with Kubernetes, CICD pipelines, and persistent integrations.",
      "Developed Asterias, a declarative asset lifecycle management platform with a GraphQL API for querying microservice assets.",
      "Extended Java and Python SDK Starter Kits, empowering developers to efficiently build backend and frontend services.",
      "Led a tech talk for Intuit about ICE at DeveloperWeek 2022 in Austin, TX and published an Intuit engineering blog on Building Real Time Interactive Experiences Using In-App Push at Intuit."
    ],
    current: false,
    logo: "/assets/images/intuit.jpeg"
  },
  {
    id: "splunk",
    company: "Splunk Inc",
    position: "Senior Product Manager - Search Orchestration",
    startDate: "08/2024",
    endDate: "Present",
    location: "Oakland, CA / San Francisco, CA",
    description: "Search Service, Search Catalog, and Splunk Processing Language Service Owner responsible for building product roadmap, defining product specs, user stories, mockups, and acceptance criteria in collaboration with engineering.",
    technologies: ["Cloud Data Services", "Batch/Stream Data Processing", "Metadata Management", "Search Platform"],
    achievements: [
      "Built search platform services/products focused on large scale search processing, query language, high availability, performance and scalability.",
      "Collaborated with Engineering, QA, SRE, and release teams to plan, drive, and execute product release cycles.",
      "Collaborated with product marketing to support creation of customer driven messaging and content.",
      "Splunk .conf18 Speaker, Splunk .conf19 Search Tech Booth Leader."
    ],
    current: false,
    logo: "/assets/images/splunk.jpeg"
  },
  {
    id: "cloud-surf",
    company: "Cloud Surf Inc",
    position: "Founder & CEO",
    startDate: "03/2014",
    endDate: "12/2019",
    location: "Oakland, CA",
    description: "AirBnB for General Aviation Parking via Mobile & Web.",
    technologies: ["Mobile", "Web", "Aviation", "Analytics"],
    achievements: [
      "Launched a platform for general aviation parking and analytics.",
      "Developed and managed all aspects of the business and technology."
    ],
    current: false,
    logo: "/assets/images/profile2.png"
  },
  {
    id: "openseat",
    company: "OpenSeat Technologies Inc",
    position: "CEO & Co-Founder",
    startDate: "01/2016",
    endDate: "01/2017",
    location: "Pleasanton, CA",
    description: "Mobile Platform for the Hair Industry – Connecting the world with licensed hair professionals, salons/barbershops, and hair industry vendors through digital services and ecommerce.",
    technologies: ["Mobile", "Ecommerce", "Platform"],
    achievements: [
      "Developed and launched a mobile platform for the hair industry."
    ],
    current: false,
    logo: "/assets/images/profile2.png"
  },
  {
    id: "deanza",
    company: "De Anza College",
    position: "Adjunct Faculty (Computer Information Systems Department)",
    startDate: "01/2018",
    endDate: "Present",
    location: "Cupertino, CA",
    description: `Adjunct Faculty teaching a range of Computer Information Systems courses, focusing on programming, cloud computing, big data, and project management.  
**Courses taught include:**

- **CIS 22A: Beginning Programming Methodologies in C++**  
  Fundamentals of programming and problem-solving in C++. Emphasis on structured procedural programming, with an introduction to object-oriented concepts. Students design, code, document, debug, and test introductory-level C++ programs.

- **CIS 35A: Java Programming**  
  Introduction to Java programming, including primitive types, flow control, file I/O, objects, classes, inheritance, interfaces, packages, data structures, and exception handling.

- **CIS 35B: Advanced Java Programming**  
  Advanced Java topics: abstract classes, interfaces, generics, design patterns, reflection, exception handling, multi-threading, sockets, JDBC, and web programming. Team-based projects and software engineering practices.

- **CIS 36A: Introduction to Computer Programming Using Java**  
  Problem-solving and algorithmic thinking using Java. Focus on structured procedural programming and an introduction to object-oriented programming.

- **CIS 36B: Intermediate Problem Solving in Java**  
  Intermediate Java: strings, multi-dimensional arrays, classes, references, and linked lists. Emphasis on design, programming style, documentation, testing, and debugging.

- **CIS 44F: Introduction to Big Data and Analytics**  
  Concepts in big data, including management of structured/unstructured data, large-scale database design, map-reduce, real-time analytics, classification, and predictive analytics.

- **CIS 64E: Fundamentals of Large Scale Cloud Computing**  
  Design, implementation, and deployment of large-scale distributed systems. Topics: concurrency, synchronization, event handling, inter-process communication, storage management, distributed objects, security, and service discovery.

- **CIS 64C: Introduction to PL/SQL**  
  Oracle PL/SQL programming: data definition, manipulation, control structures, objects, error handling, triggers, transactions, and advanced features.

- **CIS 95F: Managing Cloud Projects**  
  Cloud strategy, governance, administration, support, monitoring, billing, and documentation. Standards, protocols, and management of cloud-connected devices for optimized expense, security, and compliance.
`,
    technologies: ["Google Cloud Platform", "AWS", "Java", "Security", "Digital Forensics"],
    achievements: [
      "Taught CIS 64E, CIS 95F, CIS 102, CIS 104, CIS 35A/B/36A/B."
    ],
    current: true,
    logo: "/assets/images/deanza.png"
  },
  {
    id: "cmu-teaching",
    company: "Carnegie Mellon University",
    position: "Graduate Teaching Assistant",
    startDate: "01/2015",
    endDate: "08/2016",
    location: "Pittsburgh, PA",
    description: "Teaching assistant for software development and architecture courses",
    technologies: ["Java", "Software Architecture", "Mobile Development"],
    achievements: [
      "18-641: F15 - Java for Smartphone Development - Department of Electrical & Computer Engineering",
      "18-653: S15 - Software Architecture & Design - Department of Electrical & Computer Engineering"
    ],
    current: false,
    logo: "/assets/images/cmu.jpeg"
  },
  {
    id: "kaiser-permanente",
    company: "Kaiser Permanente",
    position: "SOA Technical Product Management",
    startDate: "08/2012",
    endDate: "10/2018",
    location: "Pleasanton, CA; Oakland, CA",
    description: "Technical product management for service-oriented architecture systems",
    technologies: ["SOA", "Product Management", "Healthcare IT"],
    achievements: [
      "Led the development, implementation, and production rollout of Splunk Shared Technical Service (Logging-as-a-Service) and Splunk ITSI Shared Technical Service (Application Monitoring-as-a-Service) across the enterprise, supporting 1.7TB+ daily volume and 200+ internal customers.",
      "Developed demand forecasting and capacity planning for SOA products, aggregating and forecasting business IT demands for optimal systems integration and infrastructure utilization.",
      "Implemented enterprise-wide caching capability using Redislabs and XC10 to address scalability, fault tolerance, and performance.",
      "Led implementation of HACMP & HADR capabilities leveraging F5/GTM and Load Balancing across multiple datacenters.",
      "Procured and deployed physical infrastructure for WebSphere Service Registry and Repository v8.0.",
      "Managed cross-functional teams for infrastructure product upgrades, scaling to multiple datacenters and launching products in production environments."
    ],
    current: false,
    logo: "/assets/images/kp.jpeg"
  },
  {
    id: "first-tee",
    company: "The First Tee",
    position: "Assistant Coach",
    startDate: "2011",
    endDate: "Present",
    location: "San Francisco, CA; Pittsburgh, PA",
    description: "Assistant golf coach for youth development program",
    technologies: ["Golf Instruction", "Youth Development"],
    achievements: [
      "Coached youth in golf and life skills development",
      "Promoted character development through sports"
    ],
    current: false,
    logo: "/assets/images/tftsf.jpg"
  },
  {
    id: "bank-of-america",
    company: "Bank of America Merrill Lynch",
    position: "Global Corporate and Commercial Investment Banking MBA Tech Associate",
    startDate: "06/2011",
    endDate: "08/2011",
    location: "Charlotte, NC",
    description: "Summer internship in investment banking technology",
    technologies: ["Investment Banking", "Financial Technology"],
    achievements: [
      "Created and sustained ongoing initiative investment planning processes, including estimation, capacity planning, resource allocation, and pipeline management.",
      "Developed and managed a Corporate Banking Plan and Supply and Demand reporting, integrating new divisions into the Technology Banking Plan.",
      "Built an enhanced estimation model using Monte Carlo simulation to optimize project portfolio distribution within Global Technology and Operations ($494M).",
      "Developed modeled template reports for onboarding new groups for Capacity Planning and Estimate Modeling Tooling."
    ],
    current: false,
    logo: "/assets/images/bofa.png"
  },
  {
    id: "ofacs-llc",
    company: "OFACS LLC",
    position: "Co-Founder",
    startDate: "10/2010",
    endDate: "Present",
    location: "Pittsburgh, PA; Pleasanton, CA",
    description: "Co-founded consulting services company",
    technologies: ["Consulting", "Business Development", "Energy Planning"],
    achievements: [
      "Co-founded consulting services company",
      "Led energy planning and financial analysis projects",
      "Secured $8M grant proposal finalist position with US Department of Energy"
    ],
    current: false,
    logo: "/assets/images/profile2.png"
  },
  {
    id: "lets-face",
    company: "Lets Face",
    position: "Consultant",
    startDate: "08/2008",
    endDate: "11/2008",
    location: "Shanghai, China",
    description: "Consulting role in international business",
    technologies: ["International Business", "Consulting"],
    achievements: [
      "Provided consulting services for international business operations",
      "Gained international business experience in China"
    ],
    current: false,
    logo: "/assets/images/profile2.png"
  },
  {
    id: "ibm",
    company: "IBM",
    position: "Senior Software Engineer",
    startDate: "07/2005",
    endDate: "03/2010",
    location: "Burlingame, CA; Raleigh, NC; Foster City, CA; Pittsburgh, PA",
    description: "Senior software engineering role at IBM",
    technologies: ["Java", "Software Engineering", "Enterprise Software"],
    achievements: [
      "Resolved multiple $1-5mm high severity cases of business intelligence software products.",
      "Improved case resolution time by 20%, scaling to the entire Support Organization.",
      "Managed multiple internal and external client relationships on end-to-end IBM WebSphere product case scenarios involving $1-5mm cases.",
      "Tested, implemented, and deployed IBM software applications to internal and external clients.",
      "Promoted curriculum for consultants, application and integration developers detailing IBM WebSphere software platforms.",
      "Deployed IBM WebSphere software using various programming languages to assist consultants."
    ],
    current: false,
    logo: "/assets/images/ibm.png"
  },
  {
    id: "lbl",
    company: "Lawrence Berkeley National Laboratory",
    position: "Research Associate",
    startDate: "01/2005",
    endDate: "12/2005",
    location: "Berkeley, CA",
    description: "Research associate in computational biology",
    technologies: ["Computational Biology", "Monte Carlo", "Artificial Intelligence", "RNA/DNA Analysis"],
    achievements: [
      "Assessed secondary structure accuracy of candidate RNA genes using Monte Carlo and Artificial Intelligence algorithms",
      "Developed software scripts to perform computational analysis of RNA/DNA sequences to identify and characterize RNA biomolecules"
    ],
    current: false,
    logo: "/assets/images/lbnl.jpeg"
  },
  {
    id: "uc-berkeley-ta",
    company: "University of California, Berkeley",
    position: "Teaching Assistant",
    startDate: "Spring 2005",
    endDate: "Spring 2005",
    location: "Berkeley, CA",
    description: "Teaching assistant for computational engineering course",
    technologies: ["Computational Engineering", "Teaching"],
    achievements: [
      "E39B: Introduction to Computational Engineering Science – Department of Engineering Science"
    ],
    current: false,
    logo: "/assets/images/berkeleyengineering.png"
  }
]; 